class AccountConfirmationUsersController {
    static controller($scope) {
      'ngInject';


    }
}

export default AccountConfirmationUsersController.controller;



// WEBPACK FOOTER //
// ./src/users/forgot-password/account-confirmation.users.controller.js